import { env } from './env';

if (!env.api.SERVER_API_URL) {
    throw new Error('VITE_SERVER_API_URL is not configured. Set it in your .env file.');
}

export const apiConfig = {
    baseUrl: `${env.api.SERVER_API_URL.replace(/\/+$/, '')}/api/`,
    useMock: env.USE_MOCK,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
};

